import bus from "../../../app/bus";

// 导航栏在 pjax 容器之外，服务端渲染一次就不再重建，所有状态都跟着页面在这里改。
const header = document.querySelector(".site-header.business");

if (header) {
    /**
     * 把一条地址归一化成导航基准路径，与 PHP 侧 iro_nav_normalize_path() 同一套规则：
     * 取路径、解码、去掉首尾斜杠
     * @param {string} value 菜单地址或绝对路径
     * @returns {string}
     */
    const normalizePath = (value) => {
        let pathname = "";

        try {
            pathname = new URL(value, window.location.origin).pathname;
        } catch {
            return "";
        }

        const path = pathname.split("/").filter(Boolean).join("/");

        try {
            return decodeURIComponent(path);
        } catch {
            return path;
        }
    };

    // 当前项由 PHP 在服务端先打一次（无 JS 时也对），但导航栏不在 pjax 容器里，
    // 换页后那些 class 会停在上一页，所以每次页面加载都按基准路径重判一遍
    const syncCurrent = () => {
        const current = String(_iro.page?.nav_path ?? "");

        header.querySelectorAll(".menu a").forEach((link) => {
            link.classList.toggle(
                "is-current",
                normalizePath(link.getAttribute("href") ?? "") === current,
            );
        });
    };

    // 非首页常驻深色底；首页跟原版一样，滚过 5% 或向下滚才变
    let progress = 0;
    let direction = "none";

    const applyBg = () => {
        header.classList.toggle(
            "bg",
            !_iro?.page?.is_home || progress >= 5 || direction === "down",
        );
    };

    bus.on("scroll:update", (state) => {
        progress = state.progress;
        direction = state.direction;
        applyBg();
    });

    _iro.hooks.onPageLoaded(() => {
        progress = 0;
        direction = "none";
        applyBg();
        syncCurrent();
    });
}
